/**
 * 系统管理路由
 */
 const Layout = () => import(/* webpackChunkName: "Layout" */'@serviceapp/systemManage/Router.vue')
export default [
    {
        path: '/systemManage',
        name: 'SystemManage',
        component: Layout,
        meta: { text: '系统管理' },
        children: [
            {
                path: 'organizationManage',
                name: 'organizationManage',
                component: () => import(/* webpackChunkName: "organizationManage" */'@serviceapp/systemManage/organizationManage/Index.vue'),
                meta: { text: '组织架构管理' }
            },
            {
                path: 'logManage',
                name: 'logManage',
                component: () => import(/* webpackChunkName: "logManage" */'@serviceapp/systemManage/logManage/Index.vue'),
                meta: { text: '日志管理' }
            },
            {
                path: 'noticeManage',
                name: 'noticeManage',
                component: () => import(/* webpackChunkName: "noticeManage" */'@serviceapp/systemManage/noticeManage/Index.vue'),
                meta: { text: '公告管理' }
            },
            {
                path: 'roleManage',
                name: 'roleManage',
                component: () => import(/* webpackChunkName: "roleManage" */'@serviceapp/systemManage/roleManage/Index.vue'),
                meta: { text: '角色管理' }
            },
            {
                path: 'ruserGroupManage',
                name: 'ruserGroupManage',
                component: () => import(/* webpackChunkName: "ruserGroupManage" */'@serviceapp/systemManage/ruserGroupManage/Index.vue'),
                meta: { text: '用户组管理' }
            },
            {
                path: 'apiManage',
                name: 'apiManage',
                component: () => import(/* webpackChunkName: "apiManage" */'@serviceapp/systemManage/apiManage/Index.vue'),
                meta: { text: '接口管理' }
            },
            {
                path: 'loginRuleManage',
                name: 'loginRuleManage',
                component: () => import(/* webpackChunkName: "loginRuleManage" */'@serviceapp/systemManage/loginRuleManage/Index.vue'),
                meta: { text: '登录规则管理' }
            },
            {
                path: 'passwordManage',
                name: 'passwordManage',
                component: () => import(/* webpackChunkName: "passwordManage" */'@serviceapp/systemManage/passwordManage/Index.vue'),
                meta: { text: '密码规则管理' }
            },
            {
                path: 'blackManage',
                name: 'blackManage',
                component: () => import(/* webpackChunkName: "blackManage" */'@serviceapp/systemManage/blackManage/Index.vue'),
                meta: { text: '黑名单管理' }
            },
            {
                path: 'whiteManage',
                name: 'whiteManage',
                component: () => import(/* webpackChunkName: "whiteManage" */'@serviceapp/systemManage/whiteManage/Index.vue'),
                meta: { text: '白名单管理' }
            },
            {
                path: 'ruserIpManage',
                name: 'ruserIpManage',
                component: () => import(/* webpackChunkName: "ruserIpManage" */'@serviceapp/systemManage/ruserIpManage/Index.vue'),
                meta: { text: '用户IP绑定' }
            },
            {
                path: 'functionManage',
                name: 'functionManage',
                component: () => import(/* webpackChunkName: "functionManage" */'@serviceapp/systemManage/functionManage/Index.vue'),
                meta: { text: '功能管理' }
            },
            {
                path: 'userManage',
                name: 'userManage',
                component: () => import(/* webpackChunkName: "functionManage" */'@serviceapp/systemManage/userManage/Index.vue'),
                meta: { text: '用户管理' }
            },
            {
                path: 'departmentParkingAmount',
                name: 'departmentParkingAmount',
                component: () => import(/* webpackChunkName: "functionManage" */'@serviceapp/systemManage/departmentParkingAmount/Index.vue'),
                meta: { text: '部门停车费管理' }
            }
        ]
    },
]
